import { gql } from "@apollo/client";

export const RETRIEVE_REVIEWS = gql`
    query gqlRetrieveReviews($nIDRestaurant: Int!) {
        data: gqlRetrieveReviews(nIDRestaurant: $nIDRestaurant) {
            nID
            dDate
            sCustomerName
            sWaiterName
            rating
            sReview
        }
    }
`;